<template>
	<div class="field limit-rows">
		<div class="control">
			<div class="select is-small">
				<select @change="change">
					<option :value="0">Rows Per Page</option>
					<option :value="5">5</option>
					<option :value="10">10</option>
					<option :value="20">20</option>
					<option :value="50">50</option>
					<option :value="100">100</option>
					<option :value="250">250</option>
					<option :value="1000000">All</option>
				</select>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        props: {
            value: Number
		},
		methods: {
			change(e) {
				if (e.target.value !== "0") {
					this.$emit('input', parseInt(e.target.value))
				}
			}
		}

    }
</script>